/**
 * TRF's published contact details (https://trf.org/contact-us).
 *
 * #3306 (Victor, 2026-10-26): the pre-screen appeal is gone. A family the
 * pre-screen stops reaches TRF by email or phone instead, so the stop screen
 * and the wizard's eligibility stop both show these. They are the
 * organisation's details, not form copy, so they are not a TRF-editable slot.
 */
export const TRF_CONTACT_EMAIL = 'info@trf.org';
/** As trf.org prints it. */
export const TRF_CONTACT_PHONE = '(725) 529-9035';
/** The same number for a `tel:` link. */
export const TRF_CONTACT_PHONE_TEL = '+17255299035';

/** Who a family writes to once the application cycle has closed (Melanie,
 *  2026-11-03). Kept in lockstep with `CYCLE_CLOSED_CONTACT_EMAIL` in
 *  backend/src/services/cycleSubmissionGuard.js. The closed screen's own
 *  wording (copy slots `apply.cycle_closed.*`) names it too, where TRF can
 *  change it in the copy editor. */
export const CYCLE_CLOSED_CONTACT_EMAIL = 'melanie@trf.org';
